import moment from 'moment';

import { statusTaskType } from './colors';
import { formatDate, formatTaskTime, toDayEnd, toDayStart } from './formats';

const getStatusType = (values, colorField) => {
  if (!colorField) return null;

  const itemId = values.getIn([colorField.get('id'), '0']);
  const item = itemId && colorField.getIn(['config', 'items']).find((i) => i.get('id') === itemId);
  return item ? statusTaskType(itemId) : null;
};

/**
 * Записи сцены в задачи диаграммы.
 *
 * Порядок берём по ключу сцены
 */
export function recordsToTasks(
  records,
  { startId, endId, titleId, employeeId, progressId, cell, colorField, startField, endField },
) {
  if (!records || !startId) return [];

  const tasks = [];
  const seen = new Set();

  const orderedKeys = [...records.keys()].sort((a, b) => a - b);

  orderedKeys.forEach((key) => {
    const record = records.get(key);
    const values = record && record.get('values');
    if (!values) return;

    const rawStart = values.get(startId);
    if (!rawStart) return;
    const start = new Date(rawStart);

    const recordId = record.get('id');
    if (seen.has(recordId)) return;
    seen.add(recordId);

    const rawEnd = endId && values.get(endId);
    const realEnd = rawEnd ? new Date(rawEnd) : null;
    const hasRange = realEnd && realEnd > start;

    // Даты отдаём как есть: по сетке масштаба бар выравнивает сама библиотека, а в запись
    // мы пишем не то, что она вернёт, а сдвиг в единицах масштаба — см. useTaskEdit.
    // У записи без конца бар синтетический, шириной в одну ячейку
    const barStart = toDayStart(start, startField);
    const end = hasRange ? toDayEnd(realEnd, endField) : moment(barStart).add(cell.step, cell.unit).toDate();

    const title = (titleId && values.get(titleId)) || record.get('title');
    const progress = progressId ? Number(values.get(progressId)) || 0 : 0;

    tasks.push({
      id: recordId,
      text: title ? String(title) : String(recordId),
      employees: (employeeId && values.get(employeeId)?.toJS()) || [],
      start: barStart,
      end,
      progress: Math.min(100, Math.max(0, progress)),
      type: getStatusType(values, colorField) || 'task',
      startText: formatDate(start),
      startTime: formatTaskTime(start, startField),
      endText: realEnd ? formatDate(realEnd) : '',
      endTime: realEnd ? formatTaskTime(realEnd, endField) : '',
    });
  });

  return tasks;
}
